import { copyText } from "../../utils/copyText";

export function referralShareCopy({ kind, displayName }) {
  if (kind === "creator-join") {
    return "Come create with me on 100ViewsOnly — no algorithm, real payouts, Canadian creators.";
  }
  if (kind === "creator-fan") {
    const who = displayName ? `${displayName} is` : "I'm";
    return `${who} on 100ViewsOnly — the first 100 viewers get in free. Come see the work.`;
  }
  return "Come join me on 100ViewsOnly — Canada's creator platform where the first 100 viewers get in free.";
}

export async function shareReferral({ platform, url, text, onToast }) {
  if (!url) return;
  const payload = `${text} ${url}`;
  const encodedLink = encodeURIComponent(url);
  const encodedText = encodeURIComponent(text);

  if (platform === "instagram" || platform === "tiktok") {
    await copyText(payload);
    onToast?.(
      platform === "instagram"
        ? "Link copied — paste it in your Instagram bio, Story, or DM"
        : "Link copied — paste it in your TikTok bio or DM"
    );
    window.open(
      platform === "instagram" ? "https://instagram.com" : "https://tiktok.com",
      "_blank",
      "noopener,noreferrer"
    );
    return;
  }

  if (platform === "more") {
    if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
      try {
        await navigator.share({ title: "100ViewsOnly", text, url });
      } catch {
        /* user cancelled */
      }
      return;
    }
    await copyText(payload);
    onToast?.("Link copied — paste it anywhere you'd like");
    return;
  }

  const urls = {
    whatsapp: `https://wa.me/?text=${encodedText}%20${encodedLink}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}&quote=${encodedText}`,
    email: `mailto:?subject=${encodeURIComponent("Join me on 100ViewsOnly")}&body=${encodedText}%20${encodedLink}`,
  };

  if (!urls[platform]) return;
  onToast?.(`Opening ${platform.charAt(0).toUpperCase() + platform.slice(1)}…`);
  window.open(urls[platform], "_blank", "noopener,noreferrer");
}
